import axios from 'axios';
import globalInfo from '../../../global.vue';
// const path = 'https://exam-app.noteach.com.cn/api'; //请求主域名上线需要更换
const path = `${window.__nb_api_host || 'https://exam-app.nobook.com'}/api`;
// const token = 'https://passport.noteach.com.cn'; //请求主域名上线需要更换
const token = window.__nb_passport_api || 'https://passport.nobook.com';

axios.interceptors.request.use(config => {
    config.headers["x-nb-productid"] = globalInfo.pid;
    return config;
}, error => {
    return Promise.reject(error);
});

//登录信息
export const getuserinfo  = params => { return axios.get(`${ path }/teachermanager/getUserInfo`,{params:params}).then(res => res.data); };


//修改班级名称
export const editclass = params => { return axios.post(`${ path }/teachermanager/classGrade/edit`,params).then(res => res.data); };
//获取实验列表
export const getexamlist = params => { return axios.get(`/experiment/getexamlist`,{params:params}).then(res => res.data); };

//编辑备注
export const editclassusermarkname = params =>{ return axios.post(`/classmanage/editclassusermarkname`,params).then(res => res.data)};
//批量添加学生
export const batchaddclassuser = params => { return axios.post(`${ path }/teachermanager/classGrade/batchAdd`,params).then(res => res.data); };

//实验掌握情况
export const getexperextent = params => { return axios.get(`/experiment/getexperextent`,{params:params}).then(res => res.data); };


//自测记录
export const gettestexam = params => { return axios.get(`${ path }/test/list`,{params:params}).then(res => res.data); };

//自测统计
export const getusertestexamcount = params => { return axios.get(`/test/getusertestexamcount`,{params:params}).then(res => res.data); };
export const gettestrecord = (url,params) => { return axios.get(`${ path }/count/countChartData${url}`,{params:params}).then(res => res.data); };
//学生考试记录
export const getexamrecord = params => { return axios.get(`${ path }/teachermanager/exammanager/examlist`,{params:params}).then(res => res.data); };

//考试详细
export const getexamanalyse = params => { return axios.get(`${ path }/teachermanager/exercise/getStudentExamInfo`,{params:params}).then(res => res.data); };

//班级统计
export const getclassfraction = params => { return axios.get(`/classmanage/getclassfraction`,{params:params}).then(res => res.data); };

//发布实验单次统计
export const getuserexamcount = params => { return axios.get(`${ path }/teachermanager/classGrade/userExperimentInfo`,{params:params}).then(res => res.data); };
//用户已考过实验
export const getuserexam = params => { return axios.get(`${ path }/teachermanager/classGrade/userSingleExperimentList`,{params:params}).then(res => res.data); };

//身份选择
export const saveuserinfo = params => { return axios.post(`/user/saveuserinfo`,params).then(res => res.data); };

//单个实验统计
export const countclassexaminfo = params => { return axios.get(`/classmanage/countclassexaminfo`,{params:params}).then(res => res.data); };

//撤销发布
export const revokepublic = params => { return axios.post(`/classmanage/revokepublic`,params).then(res => res.data); };
//移除学生
export const delstudent = params => { return axios.post(`/classmanage/delstudent`,params).then(res => res.data); };
//解散班级
export const delclass = params => { return axios.post(`${ path }/teachermanager/classGrade/dissolve`,params).then(res => res.data); };
//毕业班级
export const graduation = params => { return axios.post(`/classmanage/graduation`,params).then(res => res.data); };
//学校班级
export const getschoolclass = params => { return axios.get(`/classmanage/getschoolclass`,{params:params}).then(res => res.data); };
//转班
export const changeclass = params => { return axios.post(`/classmanage/changeclass`,params).then(res => res.data); };
//获取地区
export const getarea = params => { return axios.get(`/package/getarea`,{params:params}).then(res => res.data); };
export const countryList = params => { return axios.get(`/country/list`,{params:params}).then(res => res.data); };
export const schoolList = params => { return axios.get(`/school/list`,{params:params}).then(res => res.data); };
export const selectprovince = params => { return axios.post(`/user/selectprovince`,params).then(res => res.data); };
export const getunfinishexamnum = params => { return axios.get(`/student/getunfinishexamnum`,{params:params}).then(res => res.data); };

/****拆分后调用接口****/
export const getexamtoken = params => { return axios.get(`${ token }/login/getexamtoken`,{params:params}).then(res => res.data); };
export const getVipByPackageId = params => { return axios.get(`${ path }/package/getVipByPackageId`,{params:params}).then(res => res.data); };
//实验库列表
export const getexpertestinfo = params => { return axios.get(`${path}/jiashicoursere/list`,{params:params}).then(res => res.data); };

//教师信息补全
export const complementTeacherInfo = params => { return axios.post(`${path}/teachermanager/complementTeacherInfo`,params).then(res => res.data); };
//学生信息补全
export const editUserInfo = params => { return axios.post(`${path}/teachermanager/editUserInfo`,params).then(res => res.data); };
//自测获取单次测试详情
export const oneInfo = params => { return axios.get(`${path}/test/info`,{params:params}).then(res => res.data); };

//班级列表
export const getclasslist = params => { return axios.get(`${path}/teachermanager/classGrade/list`,{params:params}).then(res => res.data); };

//新建班级
export const addclass = params => { return axios.post(`${path}/teachermanager/classGrade/add`,params).then(res => res.data); };

//班级信息
export const getclassinfo = params => { return axios.get(`${path}/teachermanager/classGrade/info`,{params:params}).then(res => res.data); };
//班级成员
export const getclassuser = params => { return axios.get(`${path}/teachermanager/classGrade/userList`,{params:params}).then(res => res.data); };
//实验发布列表
export const getpushlist = params => { return axios.get(`${path}/teachermanager/exammanager/pushlist`,{params:params}).then(res => res.data); };
//班级单个实验统计
export const getClassExperimentStatistics = params => { return axios.get(`${path}/teachermanager/statistics/getClassExperimentStatistics`,{params:params}).then(res => res.data); };
//班级掌握列表
export const getClassExperimentMasteryInfo = params => { return axios.get(`${path}/teachermanager/statistics/getClassExperimentMasteryInfo`,{params:params}).then(res => res.data); };
//修改学生备 注
export const editUserMark = params => { return axios.post(`${path}/teachermanager/classGrade/editUserMark`,params).then(res => res.data); };
//班级管理实验掌握情况/考试中心考试统计
export const getClassExamInfo = params => { return axios.get(`${path}/teachermanager/statistics/getClassExamInfo`,{params:params}).then(res => res.data); };
//新版个人实验统计详情
export const getStudentExamInfo = params => { return axios.get(`${path}/teachermanager/exercise/getStudentExamInfo`,{params:params}).then(res => res.data); };
//发布实验
export const pushexam = params => { return axios.post(`${path}/teachermanager/exammanager/push`,params).then(res => res.data); };
//撤销/删除实验
export const cancelExam = params => { return axios.post(`${path}/teachermanager/exammanager/cancel`, params).then(res => res.data); };

//发布实验统计
export const getclassexaminfo = params => { return axios.get(`${path}/teachermanager/statistics/getClassExamInfo`,{params:params}).then(res => res.data); };

// //发布实验单次统计
export const getstudentexaminfo1 = params => { return axios.get(`${path}/teachermanager/exercise/getStudentExamInfo`,{params:params}).then(res => res.data); };

//学生考试详情
export const getstudentexaminfo = params => { return axios.get(`${ path }/teachermanager/classGrade/userExperimentList`,{params:params}).then(res => res.data); };
//班级考试列表
export const getClassExamListInfo = params => { return axios.get(`${ path }/teachermanager/statistics/getClassExamListInfo`,{params:params}).then(res => res.data); };

//搜索班级
export const searchclass = params => { return axios.get(`${path}/teachermanager/classGrade/classInfoByCode`,{params:params}).then(res => res.data); };

//加入班级
export const joinclass = params => { return axios.post(`${path}/teachermanager/joinClass`,params).then(res => res.data); };

//移除学生
export const delUser = params => { return axios.post(`${path}/teachermanager/classGrade/delUser`,params).then(res => res.data); };



// WEBPACK FOOTER //
// ./src/assets/js/api/exam_api.js